var _excluded = ["id", "actions", "error", "errorMessage", "success", "className", "name", "label", "info", "outlined"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { ActionsWrapper, TextFieldWrapper, StyledTextField, ErrorMessage, IconWrapper, InputWrapper, InputRow } from './StyledTextField';
import InputLabel from '../InputLabel';
import Icon from '../Icon';
import { SuccessIcon } from '../Icons';
import colors from '../../styles/colors';
var TextField = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
    actions = _ref.actions,
    error = _ref.error,
    errorMessage = _ref.errorMessage,
    success = _ref.success,
    className = _ref.className,
    name = _ref.name,
    label = _ref.label,
    info = _ref.info,
    outlined = _ref.outlined,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(TextFieldWrapper, {
    className: className
  }, (info || label) && /*#__PURE__*/React.createElement(InputLabel, {
    name: name,
    label: label,
    info: info
  }), /*#__PURE__*/React.createElement(InputRow, null, /*#__PURE__*/React.createElement(InputWrapper, null, /*#__PURE__*/React.createElement(StyledTextField, _extends({
    id: id,
    ref: ref,
    name: name,
    error: error,
    success: success,
    outlined: outlined
  }, rest)), success && /*#__PURE__*/React.createElement(IconWrapper, null, /*#__PURE__*/React.createElement(Icon, {
    size: "sz16",
    as: SuccessIcon,
    color: colors.green
  }))), actions && /*#__PURE__*/React.createElement(ActionsWrapper, null, actions)), error && errorMessage && /*#__PURE__*/React.createElement(ErrorMessage, {
    "data-testid": "".concat(id, "-validation-message")
  }, errorMessage));
});
TextField.propTypes = {
  id: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  autoComplete: PropTypes.oneOf(['on', 'off', 'username']),
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.oneOf(['date', 'email', 'number', 'password', 'text', 'url', 'search']),
  /** Use in combination with an event hook. */
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  onKeyDown: PropTypes.func,
  onKeyPress: PropTypes.func,
  onKeyUp: PropTypes.func,
  success: PropTypes.bool,
  outlined: PropTypes.bool,
  actions: PropTypes.element
};
TextField.defaultProps = {
  autoComplete: 'off',
  className: undefined,
  defaultValue: undefined,
  disabled: false,
  error: false,
  errorMessage: undefined,
  name: undefined,
  onBlur: undefined,
  onChange: undefined,
  placeholder: '',
  type: 'text',
  value: undefined,
  onKeyDown: undefined,
  onKeyPress: undefined,
  onKeyUp: undefined,
  success: false,
  outlined: true,
  actions: undefined
};
TextField.displayName = 'TextField';
export default TextField;